/* Sticky Jams cart drawer — upsell "+ Add" (always-bound, delegated). */
(function () {
  if (window.__sjCartInit) return;
  window.__sjCartInit = true;

  function refreshDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (data.sections && data.sections['cart-drawer'] && drawer) {
      var tmp = document.createElement('div');
      tmp.innerHTML = data.sections['cart-drawer'];
      var ni = tmp.querySelector('.drawer__inner');
      var ci = drawer.querySelector('.drawer__inner');
      if (ni && ci) ci.replaceWith(ni);
      drawer.classList.remove('is-empty');
    }
    try {
      document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
        var s = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span');
        if (s && data.item_count != null) s.textContent = data.item_count;
      });
    } catch (e) {}
  }

  /* Merged rows (one variant that Shopify split into several lines, see cart-drawer.liquid):
     set the whole quantity on the first line and zero the rest in ONE update; Shopify re-splits
     for its discounts, and the drawer re-renders them as one row again. Runs in the capture phase
     so Dawn's per-line handlers never see these events. */
  function updateMerged(keysAttr, qty) {
    var keys = keysAttr.split(',').filter(Boolean);
    var updates = {};
    keys.forEach(function (k, i) { updates[k] = i === 0 ? qty : 0; });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.add('sj-updating');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        refreshDrawer(data);
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections && data.sections['cart-icon-bubble']) {
          var t = document.createElement('div');
          t.innerHTML = data.sections['cart-icon-bubble'];
          var nb = t.querySelector('.shopify-section');
          if (nb) bubble.innerHTML = nb.innerHTML;
        }
        if (data.item_count === 0 && drawer) drawer.classList.add('is-empty');
      })
      .catch(function () {})
      .then(function () { if (drawer) drawer.classList.remove('sj-updating'); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('cart-drawer .quantity__input[data-sj-keys]');
    if (!input) return;
    e.stopImmediatePropagation();
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    updateMerged(input.getAttribute('data-sj-keys'), qty);
  }, true);

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('cart-drawer cart-remove-button[data-sj-keys]');
    if (!rm) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    updateMerged(rm.getAttribute('data-sj-keys'), 0);
  }, true);

  document.addEventListener('click', function (e) {
    /* Multi-color upsell: "+ Add" opens the color row; tapping a color adds that variant. */
    var opener = e.target.closest('.sj-upsell-add[data-pick]');
    if (opener) {
      e.preventDefault();
      var card = opener.closest('.sj-upsell-card');
      var open = card.classList.toggle('is-picking');
      opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      opener.textContent = open ? 'Cancel' : '+ Add';
      return;
    }
    var btn = e.target.closest('.sj-upsell-add, .sj-upsell-swatch');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('sj-upsell-swatch')) {
      btn.closest('.sj-upsell-swatches').querySelectorAll('.sj-upsell-swatch').forEach(function (s) { s.disabled = true; });
      btn.classList.add('is-adding');
    }
    var id = btn.getAttribute('data-variant-id');
    /* Collab card: use the picked option (size/color) when the product has variants. */
    if (btn.hasAttribute('data-collab')) {
      var sel = btn.closest('.sj-collab-card').querySelector('.sj-collab-variant');
      if (sel) id = sel.value;
      var lbl = btn.querySelector('span') || btn;
      var label = lbl.textContent;
      lbl.textContent = btn.getAttribute('data-adding') || 'Adding…';
      var restore = function () { lbl.textContent = label; btn.disabled = false; };
    }
    if (!id) return;
    btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.disabled = false;
          if (restore) restore();
          var sw = btn.closest('.sj-upsell-swatches');
          if (sw) sw.querySelectorAll('.sj-upsell-swatch').forEach(function (s) { s.disabled = false; s.classList.remove('is-adding'); });
          return;
        }
        refreshDrawer(data);
      })
      .catch(function () { btn.disabled = false; if (restore) restore(); });
  });
})();
